import React, { FC } from 'react'
import Icon from '../../Core/Iconography/Icon/Icon'
import { InfoBox, ContentWrapper, IconWrapper } from './Info.styles'
import { InfoProps } from './types'

const Info: FC<InfoProps> = props => {
  return (
    <InfoBox alignItems='flex-start' margin={props.margin}>
      <ContentWrapper>{props.children}</ContentWrapper>
      <IconWrapper onClick={props.closeInfo}>
        <Icon name='close' size='s' color='main' />
      </IconWrapper>
    </InfoBox>
  )
}

export default Info
